module.exports = __webpack_public_path__ + "img/house_and_funeral.13adffbc.svg";